import React from "react"

import CardActions from '../actions/CardActions';
import AuthActions from '../actions/AuthActions';

import CardStore from '../stores/CardStore'
import AuthStore from '../stores/AuthStore'

import CardParts from './parts/Card'



export default class CardApp extends React.Component {

  constructor({match}){
    super()


    this.createPayment = this.createPayment.bind(this)
    this.getCardEntry = this.getCardEntry.bind(this)

    this.PaymentChangeHandler = this.PaymentChangeHandler.bind(this)
    this.CardErrorHandler = this.CardErrorHandler.bind(this)
    this.authChangeHandler = this.authChangeHandler.bind(this)
    this.getToken = this.getToken.bind(this)
    this.PayErrorHandler = this.PayErrorHandler.bind(this)

    this.state = {
      item:null,
      is_auth:false,
      is_card_entry:true,
      message:null,
      error_code:null
    }
  }

  componentDidMount(){

    AuthStore.addChangeListener(this.authChangeHandler)

    CardStore.addChangeListener(this.PaymentChangeHandler,"change_payment")
    CardStore.addChangeListener(this.CardErrorHandler,"error_card")
    CardStore.addChangeListener(this.PayErrorHandler,"error_pay")

    AuthActions.setAuth()

  }

  componentWillUnmount(){
    AuthStore.removeChangeListener(this.authChangeHandler)
    CardStore.removeChangeListener(this.PaymentChangeHandler,"change_payment")
    CardStore.removeChangeListener(this.CardErrorHandler,"error_card")
    CardStore.removeChangeListener(this.PayErrorHandler,"error_pay")
  }

  PaymentChangeHandler(){

      window.location = "/club/member"
  }


  updateForm(name,value){
    CardActions.update(name,value)
  }

  authChangeHandler(){
    if(AuthStore.isAuth()){
      this.setState({
        is_auth:AuthStore.isAuth()
      })
    }else{
      window.location =  "/club/login"
    }

  }


  CardErrorHandler(){
    this.setState({
      error_code: CardStore.getErrorCode(),
      message: "カード情報が認証されません。内容を確認してください。 Error Coce:" +CardStore.getErrorCode()
    })
  }

  PayErrorHandler(){
    this.setState({
      message: "支払いが認証されませんでした。支払い方法をご確認ください。Error Coce:" +CardStore.getErrorCode()
    })
  }


  getToken(card){
    this.setState({
      message: null
    })
    CardActions.createToken(AuthStore.getToken(), card)
  }

  getCardEntry(){
    //CardActions.getAvailableCard()
    this.setState({
      is_card_entry:true
    })
  }
  createPayment(){
    this.setState({
      message: null
    })

    if(this.state.is_auth){
      CardActions.paymentExe(AuthStore.getToken(), CardStore.getToken())
    }else{
      console.log("not auth!") //TODO
    }

  }

  render(){
    var cardHTML = null
    var btnHTML = null

    if(this.state.is_card_entry){
      cardHTML = <CardParts updateForm={this.updateForm} getToken={this.getToken} createPayment = {this.createPayment}/>
    }

    if(!this.state.is_card_entry){
      btnHTML = <div className="button-box">
          <button className="huge" onClick={this.getCardEntry}>カードで支払いをする</button>
        </div>
    }
    return(

      <div id="book">
        <main>
          <div className="main-pannel">


          <div className="message">{this.state.message}</div>
          {cardHTML}
          {btnHTML}

          </div>

        </main>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/components/CardApp.js